export class LocationServicesError extends Error {}
